module.exports = __webpack_public_path__ + "static/media/labs-landing-bg.6028199c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/labs-landing-bg.png
// module id = 2888
// module chunks = 0